import React, { useState, useContext } from "react"

export const LoadingTriger = React.createContext({
  loading: false,
  setLoading: (value: boolean) => {},
})

export const useLodingTrigger = () => {
  const [loading, setLoading] = useState(false)
  const loadingTrigger = useContext(LoadingTriger)
  return { loading, setLoading, loadingTrigger }
}
